var map = {
	"./Company": "b560",
	"./Company.vue": "b560",
	"./Financials": "c053",
	"./Financials copy": "8e23",
	"./Financials copy.vue": "8e23",
	"./Financials.vue": "c053",
	"./Industry": "6ed1",
	"./Industry.vue": "6ed1",
	"./Macro": "f7a1",
	"./Macro.vue": "f7a1",
	"./SingleColumn": "3ae4",
	"./SingleColumn.vue": "3ae4",
	"./Transaction": "1db5",
	"./Transaction.vue": "1db5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bea8";